import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign, Clock, Lock } from "lucide-react";

const problems = [
  {
    title: "Runaway Costs",
    description:
      "Cloud providers, serverless platforms have unpredictable pricing that may surprise you with a $$$ invoice overnight because of rogue AI scraping bots, or viral success. Using capacity-capped servers solves that with predictable, fixed costs.",
    icon: <DollarSign className="h-8 w-8 text-primary" />,
    color: "text-red-500"
  },
  {
    title: "Time Consuming",
    description:
      "Instead of creating great products, developers spend time learning AWS, DevOps, and making infrastructure scale. We handle the robust infrastructure for you automatically, so you can focus on building your product.",
    icon: <Clock className="h-8 w-8 text-primary" />,
    color: "text-blue-500"
  },
  {
    title: "Vendor Lock-in",
    description:
      "Once you've built your infrastructure on one cloud, it's next to impossible to migrate to another cloud or your own private infrastructure. Building using common primitives like VPS, Postgres, and object storage gives you the freedom to move.",
    icon: <Lock className="h-8 w-8 text-primary" />,
    color: "text-purple-500"
  }
];

export const Problems = () => {
  return (
    <section id="problems" className="container pt-24 pb-8 md:pb-16 space-y-8 md:space-y-16">
      <div className="text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Focus on building, not&nbsp;
          <span className="gradient-light dark:gradient-dark">deploying</span>
        </h2>
        <p className="text-xl text-muted-foreground md:w-3/4 mx-auto">
          DollarDeploy eliminates the biggest pain points developers face when deploying
          applications.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {problems.map(({ title, description, icon }) => (
          <Card key={title} className="bg-muted/50 border">
            <CardHeader className="flex flex-row items-center gap-4 pt-2">
              {icon}
              <CardTitle className="text-xl font-bold">{title}</CardTitle>
            </CardHeader>
            <CardContent className="text-muted-foreground">{description}</CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};
